const encode = (str) => btoa( // eslint-disable-line
    encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        (match, p1) => String.fromCharCode(`0x${p1}`),
    ),
);

const decode = (str) => decodeURIComponent(
    atob(str).split('').map( // eslint-disable-line
        (c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`,
    ).join(''),
);

export default {encode, decode};
